// removed by extract-text-webpack-plugin
module.exports = {"form":"_31rhLKTb9rh1ZA4Dp67CAX"};


//////////////////
// WEBPACK FOOTER
// ../components/CatalogueForm.module.scss
// module id = 468
// module chunks = 0